// Third Party
import React, { ReactElement } from 'react';

// Namespaces
import * as ProposalNS from '../../../modules/proposal/Proposal';

// Components
import ErrorModal from './ErrorModal';

// Utils
import { formatMessage, FormattedMessage } from '../../../utils/i18n';

type Props = {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  missingRequirements: ProposalNS.FormattedProposalTemplateRequirements;
};

class ProposalRequirementsModal extends React.Component<Props> {
  getModalBody = (): ReactElement => (
    <div>
      <FormattedMessage id="ProposalRequirementsModal.Body" />
      <ul className="requirements-list">
        {this.props.missingRequirements.map(opt => (
          <li key={opt.key}>{opt.text}</li>
        ))}
      </ul>
    </div>
  );

  onConfirm = () => {
    const { missingRequirements } = this.props;
    if (missingRequirements.length === 1 && !!missingRequirements[0].callback) {
      this.props.onCancel();
      missingRequirements[0].callback();
      return;
    }

    this.props.onConfirm();
  };

  render() {
    const { onConfirm, onCancel, missingRequirements, ...rest } = this.props;
    const label = missingRequirements.length === 1 && missingRequirements[0].actionText ? missingRequirements[0].actionText : formatMessage('Common.Close');

    return (
      <ErrorModal
        title={formatMessage('ProposalRequirementsModal.Title')}
        body={this.getModalBody()}
        confirmLabel={label}
        className="proposal-requirements-modal"
        onConfirm={this.onConfirm}
        {...rest}
      />
    );
  }
}

export default ProposalRequirementsModal;
